import React from 'react'
import { generateValidation } from 'redux-form-validation'
import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'
import ServicingLabelSelectorContainer from '../../containers/servicing-labels/servicing-label-selector-container'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

export default ({
  fields: {
    servicingLabelIds
  },
  locationId,
  handleClose,
  handleSubmit,
  loading
}) => {
  if (loading) {
    return <p>Loading...</p>
  }

  return (
    <BaseModal
      onClose={handleClose}
      title="Manage Labels"
      constraints={constraints}
      contentClassName='servicing-label-select-container'
    >
      <ModalForm onSubmit={handleSubmit} customClassName='servicing-label-select-form'>
        <ModalFormRow>
          <ModalFormBlock>
            <label>Labels</label>
            <ServicingLabelSelectorContainer locationId={locationId} {...servicingLabelIds} />
          </ModalFormBlock>
        </ModalFormRow>

        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button type='submit'>Update</button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    </BaseModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/servicing-labels/servicing-label-select-form.js